
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TshirtType } from '../../../services/lineup-service';

@Component({
    selector: 'paginator',
    templateUrl: 'paginator.html',
})
export class PaginatorComponent implements OnInit {

    /**
     * items: the array of objects
     */
    @Input() items;

    /**
     * the number of elements on one page. Default size = 8.
     */
    @Input() size = 4;
    @Input() addText = "";
    @Input() tshirt: boolean = false;

    @Output() onClick = new EventEmitter<any>();
    @Output() onAdd = new EventEmitter<any>();

    length = new Array(0);

    constructor() { }

    ngOnInit(): void {
        if(this.items && this.items.length) { 
            let itemsLength = this.tshirt ? this.items.length + 1 : this.items.length;
            this.length = new Array(Math.ceil(itemsLength / this.size));
        }
    }

    click(item: any) {
        this.onClick.emit(item);
    }

    onAddEvent(){
        this.onAdd.emit();
    }

    getItems(activeSlide, isFirst) {
        let sub = (isFirst && this.tshirt)? 1: 0;
        let sub2 = (!isFirst && this.tshirt)? 1: 0;
        let start = activeSlide * this.size - sub2;
        let len = (activeSlide * this.size) + this.size - sub - sub2;
        return this.items.slice(start, len);
    }

    public get type(): typeof TshirtType {
        return TshirtType;
      }
}




// WEBPACK FOOTER //
// /src/pages/apps/lineup/components/shared/paginator/paginator.ts